export default {
  generic_error: 'Etwas ist schiefgelaufen',
  address_not_found:
    'Entschuldigung, wir konnten diese Adresse nicht finden. Bitte versuche es erneut, indem du zuerst die Straße im Suchfeld für Adressen eingibst.',
  internal_error:
    'Leider gab es ein unerwartetes Problem mit deiner Bestellung, unser Technikteam arbeitet bereits daran 🛠️.',
};
